/* ---------------------------------- THEME --------------------------------- */
export const SET_THEME = "SET_THEME";

/* --------------------------------- SIDENAV -------------------------------- */
export const SIDE_NAV_SET_OPEN_TAB = "SIDE_NAV_SET_OPEN_TAB";
export const SIDE_NAV_SET_OPEN_TAB_ITEM = "SIDE_NAV_SET_OPEN_TAB_ITEM";
